export const liveScoreboard = {
  settings: {
    title: "现场比赛",
    subtitle: "配置比赛格式",
    matchCategory: "比赛分类",
    categories: {
      mens_singles: "男子单打",
      womens_singles: "女子单打",
      mens_doubles: "男子双打",
      womens_doubles: "女子双打",
      mixed_doubles: "混合双打",
    },
    matchFormat: "比赛长度",
    bestOf1: "单盘决胜",
    bestOf3: "三盘两胜",
    bestOf5: "五盘三胜",
    gamesPerSet: "每盘局数",
    gamesPerSetHint: "标准盘数是先赢6局。4局制在俱乐部/业余比赛中很常见。抢十 = 用一个抢十决胜整场。",
    games6: "先赢6局",
    games4: "先赢4局",
    gamesTiebreak: "抢十",
    deuceRule: "盘点规则（40-40）",
    deuceRuleHint: "黄金得分立即结束盘点——下一分赢者胜。优势制需要赢2分。",
    deuce: {
      advantage: "优势制",
      goldenPoint: "黄金得分",
    },
    tiebreak: "抢七格式",
    points7: "先赢7分",
    points10: "先赢10分",
    summary: "比赛摘要",
    format: "格式",
    bestOf: "最多",
    sets: "盘",
    points: "分",
    startMatch: "开始比赛",
    backToHome: "返回主页",
  },

  scoreboard: {
    liveMatch: "现场比赛",
    tiebreak: "抢七",
    pts: "分",
    sets: "盘",
    games: "局",
    points: "分",
    tiebreakPoints: "抢七分",
    point: "得分",
    switchServer: "交换发球",
    shareMatch: "分享现场比赛",
    linkCopied: "链接已复制到剪贴板",
    spectatorBadge: "直播中",
  },

  matchComplete: {
    title: "比赛结束！",
    congratulations: "恭喜获胜者",
    winner: "获胜者",
    setScores: "盘分数",
    set: "第",
    saveThisMatch: "保存此比赛？",
    saveMatchDescription: "是否要将此比赛添加到你的记录中？",
    saveToRecords: "保存到记录",
    discardMatch: "放弃比赛",
    startNewMatch: "开始新比赛",
  },
};
